import { render, staticRenderFns } from "./heartRateChild.vue?vue&type=template&id=4a5cfaf4&scoped=true&"
import script from "./heartRateChild.vue?vue&type=script&lang=js&"
export * from "./heartRateChild.vue?vue&type=script&lang=js&"
import style0 from "./heartRateChild.vue?vue&type=style&index=0&id=4a5cfaf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5cfaf4",
  null
  
)

export default component.exports